module.exports = __webpack_public_path__ + "static/media/9.bdc02f8d.jpg";